import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NbButtonModule, NbIconModule, NbPopoverDirective, NbPopoverModule } from '@nebular/theme';

/** Divider band above a bulk-upload group of conversion rows, with a Download menu */
@Component({
  selector: 'app-conversion-batch-header',
  standalone: true,
  imports: [CommonModule, NbButtonModule, NbIconModule, NbPopoverModule],
  template: `
    <div class="cbh">
      <b class="cbh-title">{{ title }}</b>

      <button type="button" nbButton size="small" [nbPopover]="downloadMenu" nbPopoverPlacement="bottom" nbPopoverTrigger="click">
        <nb-icon icon="download-outline"></nb-icon>
        Download
      </button>
    </div>

    <ng-template #downloadMenu>
      <div class="cr-menu">
        <button type="button" (click)="pick('csv')">CSV</button>
        <button type="button" (click)="pick('excel')">Excel</button>
      </div>
    </ng-template>
  `,
  styleUrls: ['./conversion-batch-header.component.scss'],
})
export class ConversionBatchHeaderComponent {
  @Input() title: string;
  @Output() download = new EventEmitter<'csv' | 'excel'>();

  @ViewChild(NbPopoverDirective) menuPopover?: NbPopoverDirective;

  pick(type: 'csv' | 'excel') {
    this.menuPopover?.hide();
    this.download.emit(type);
  }
}
